import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcInsertphoto(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.883 12.208a.542.542 0 0 1 .862.006l3.104 4.134a.542.542 0 0 1-.433.866H6.607a.542.542 0 0 1-.428-.874l2.156-2.773a.542.542 0 0 1 .845-.013l1.457 1.763a.542.542 0 0 0 .846-.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.5 2.75A2.75 2.75 0 0 0 2.75 5.5v13a2.75 2.75 0 0 0 2.75 2.75h13a2.75 2.75 0 0 0 2.75-2.75v-13a2.75 2.75 0 0 0-2.75-2.75zM4.25 5.5c0-.69.56-1.25 1.25-1.25h13c.69 0 1.25.56 1.25 1.25v13c0 .69-.56 1.25-1.25 1.25h-13c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  }));
}
var IcInsertphoto = createNolIcon(/*#__PURE__*/forwardRef(SvgIcInsertphoto));

export { IcInsertphoto as I };
